import i18n from '../langs'
import type { RouteRecordRaw } from 'vue-router'

const AccountSettingsView = () => import('@/views/Settings/Account/Index.vue')
const ReferrerIndex = () => import('@/views/Referrer/Index.vue')
const ReferrerOverview = () => import('@/views/Referrer/ReferrerOverview.vue')
const ReferrerDetail = () => import('@/views/Referrer/ReferrerDetail.vue')
const OnePagerLayout = () => import('@/layouts/OnePager.vue')

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: OnePagerLayout,
    meta: {
      name: i18n.global.t('ui.common.dashboard'),
    },
    children: [
      {
        path: '/',
        name: 'ReferrerView',
        component: ReferrerIndex,
        meta: {
          name: i18n.global.t('ui.common.referral_view'),
        },
        children: [
          {
            path: '',
            name: 'ReferrerOverview',
            component: ReferrerOverview,
          },
          {
            path: ':entity_id',
            name: 'ReferrerDetail',
            component: ReferrerDetail,
            props: true,
          },
        ],
      },
      {
        path: '/account-settings',
        name: 'AccountSettingsView',
        component: AccountSettingsView,
        meta: {
          name: i18n.global.t('ui.common.account_settings'),
        },
      },
    ],
  },
]

export default routes
